import { render } from "./Header.vue?vue&type=template&id=27b4eaec&ts=true"
import script from "./Header.vue?vue&type=script&lang=ts"
export * from "./Header.vue?vue&type=script&lang=ts"

import "./Header.vue?vue&type=style&index=0&id=27b4eaec&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/IT_CICD/SDK/Prod/Joymeet_frontend/GUI/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__